<div class="layout-row layout-align-start-center">
  <div class="md-subhead">
    <span>{{ seriesCount }}</span>
    <span> series</span></div>
  <div class="md-subhead" style="margin-left: 32px;">
    <span>{{ sermonCount }}</span>
    <span> sermons</span>
  </div>
</div>
